import AdminLayout from "layout/admin-layout";
import DashBoardLayout from "layout/dashboard-layout";
import DocsLayout from "layout/docs-layout";
import { Suspense, Fragment, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { AdminAuthGuard, AuthGuard, GuestGuard } from "utils/helpers/guard";
import { SuspenseScreen } from "./fragment";

interface IRoute {
  guard?: unknown;
  layout?: unknown;
  component?: unknown;
  path?: string;
  exact?: boolean;
  routes?: IRoute[];
  redirect?: string;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderRoutes = (routes: any[]) => (
  <Suspense fallback={<SuspenseScreen />}>
    <div>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;
          const redirectPath = route.redirect;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>{route.routes ? renderRoutes(route.routes) : redirectPath ? <Redirect to="/" /> : <Component {...props} />}</Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </div>
  </Suspense>
);

const routes: IRoute[] = [
  {
    exact: false,
    guard: AuthGuard,
    layout: DashBoardLayout,
    path: "/home",
    routes: [
      {
        exact: true,
        path: "/home",
        component: lazy(() => import("./pages/home/dash")),
      },
      {
        exact: true,
        path: "/home/new",
        component: lazy(() => import("./pages/home/new-number")),
      },
      {
        exact: true,
        path: "/home/new/:number",
        component: lazy(() => import("./pages/home/new-number/selected")),
      },
      {
        exact: true,
        path: "/home/number/:number",
        component: lazy(() => import("./pages/home/number")),
      },
      {
        exact: true,
        path: "/home/usage",
        component: lazy(() => import("./pages/home/usage")),
      },
      {
        exact: true,
        path: "/home/profile",
        component: lazy(() => import("./pages/profile")),
      },

      {
        component: lazy(() => import("./fragment")),
      },
    ],
  },
  {
    exact: false,
    guard: AdminAuthGuard,
    layout: AdminLayout,
    path: "/admin",
    routes: [
      {
        exact: true,
        path: "/admin",
        component: lazy(() => import("./pages/home")),
      },
      {
        exact: true,
        path: "/admin/numbers",
        component: lazy(() => import("./pages/admin/numbers")),
      },
      {
        exact: true,
        path: "/admin/packages",
        component: lazy(() => import("./pages/admin/packages")),
      },
      {
        exact: true,
        path: "/admin/profile",
        component: lazy(() => import("./pages/profile")),
      },
      {
        component: lazy(() => import("./fragment")),
      },
    ],
  },
  {
    exact: false,
    layout: DocsLayout,
    path: "/docs",
    routes: [
      {
        exact: true,
        path: "/docs",
        component: lazy(() => import("./pages/docs")),
      },
      {
        exact: true,
        path: "/docs/auth",
        component: lazy(() => import("./pages/docs/auth")),
      },
      {
        exact: true,
        path: "/docs/single",
        component: lazy(() => import("./pages/docs/single")),
      },
      {
        exact: true,
        path: "/docs/bulk",
        component: lazy(() => import("./pages/docs/bulk")),
      },
      {
        exact: true,
        path: "/docs/advance",
        component: lazy(() => import("./pages/docs/advance")),
      },
      {
        exact: true,
        path: "/docs/otp",
        component: lazy(() => import("./pages/docs/otp")),
      },
      {
        exact: true,
        path: "/docs/error",
        component: lazy(() => import("./pages/docs/error")),
      },
    ],
  },

  {
    exact: true,
    guard: GuestGuard,
    path: "/join",
    component: lazy(() => import("./pages/auth")),
  },
  {
    exact: true,
    path: "/",
    // guard: GuestGuard,
    component: lazy(() => import("./pages/public")),
  },
  {
    exact: true,
    path: "/404",
    // guard: GuestGuard,
    component: lazy(() => import("./fragment")),
  },
  {
    component: lazy(() => import("./fragment")),
  },
];

export default routes;
